import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OffersRoutingModule } from './offers-routing.module';
import { SharedModule } from '../shared/shared.module';
import { DetailComponent } from './detail/detail.component';
import { OfferListComponent } from './offer-list/offer-list.component';
import { TncComponent } from './tnc/tnc.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SvgIconModule } from "@pv-frontend/pv-shared-components/svg-icon";
// import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AccordionModule } from 'primeng/accordion';


@NgModule({
  declarations: [ DetailComponent, OfferListComponent, TncComponent],
  imports: [
    CommonModule,
    OffersRoutingModule,
    SharedModule,
    InfiniteScrollModule,
    SvgIconModule,
    AccordionModule
    // AccordionModule.forRoot()
  ]
})
export class OffersModule { }
